"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MessageAndMediaLabel = ({ body }) => (React.createElement(src_1.Text, { text: body, size: "small", textStyle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    } }));
exports.default = MessageAndMediaLabel;
